export default __webpack_public_path__ + "static/media/cross.45c4a03e.svg";